import styled from 'styled-components';

const KakaoShareButtonStyled = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background-color: var(--Yellow-50);

  & img {
    vertical-align: middle;
  }
`;

export default KakaoShareButtonStyled;
